import JackpotTemplates from "./jackpot-templates";

export default JackpotTemplates;
